import { useRef } from 'react';
import { onRender } from './intentTypes';
export function captureProps() {
    const result = {
        intent: onRender((props)=>{
            result.props = props;
        }),
        props: {}
    };
    return result;
}
export const logRenderCount = onRender(function useLogRenderCount() {
    const counter = useRef(0);
    counter.current++;
    // eslint-disable-next-line no-console
    console.log('[render]', counter.current);
});

//# sourceMappingURL=debug.js.map